import { SVGProps, Ref, forwardRef } from 'react';

export const PlayOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.722 14.247c.722.602 1.738.073 3.769-.985l2.919-1.52C13.47 10.148 15 9.352 15 8s-1.53-2.148-4.59-3.742l-2.92-1.52C5.46 1.68 4.445 1.15 3.723 1.753S3 3.73 3 6.48v3.04c0 2.75 0 4.125.722 4.727M9.762 5.5 6.845 3.98c-1.066-.556-1.698-.879-2.15-1.022l-.107-.031a3 3 0 0 0-.106.548C4.402 4.136 4.4 5.068 4.4 6.48v3.04c0 1.412.002 2.344.08 3.005.034.281.075.45.107.548l.106-.03c.453-.144 1.085-.467 2.151-1.022l2.919-1.52c1.575-.821 2.601-1.36 3.255-1.845.6-.446.585-.624.582-.653v-.006c.003-.03.019-.207-.582-.653-.654-.485-1.68-1.024-3.255-1.844m-5.32 7.6h.012zm.012-10.2h-.012z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PlayOutlinedSize16Glyph.displayName = 'PlayOutlinedSize16Glyph';
